













// import sjcl from 'sjcl';
import { Component, Vue } from 'vue-property-decorator';
import SearchIcon from 'mdi-vue/Magnify';
import AddIcon from 'mdi-vue/Plus';
import LayoutTitle from '@/components/LayoutTitle.vue';
import Select from '@/components/Select.vue';
import FormInput from '@/components/FormInput.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Toggle from '@/components/Toggle.vue';
import Accordion from '@/components/Accordion.vue';
import PermissionTree from '@/components/PermissionTree/PermissionTree.vue';
import { ValidationObserver } from 'vee-validate';

@Component({
  components: {
    ValidationObserver,
    LayoutTitle,
    Select,
    FormInput,
    SearchIcon,
    LayoutContent,
    Button,
    AddIcon,
    Toggle,
    Checkbox,
    Loader,
    Accordion,
    PermissionTree,
  },
})

export default class PCS extends Vue {
}
